import styles from './NotificationPanel.module.scss'

import React from 'react'

import classNames from 'classnames'

import Area from 'Molecules/Area'

import Typography from 'Atoms/Typography'

const RefundedGuaranteedShippingNotification = ({ className, ...props }) => {
  const classnames = classNames(className, styles.mobileHidden)
  return (
    <Area brand="primary" icon="star" noBorder invertIcon className={classnames} {...props}>
      <Typography font="bold">We’re refunding your Guaranteed Shipping fees.</Typography>
      <Typography>
        An item you bought with guaranteed delivery is delayed and won’t arrive on time. We’re making it right.
      </Typography>
    </Area>
  )
}

const MobileRefundedGuaranteedShippingNotification = ({ className, ...props }) => {
  const classnames = classNames(className, styles.mobileOnly)

  return (
    <Area brand="primary" icon="star" noBorder invertIcon className={classnames} {...props}>
      <Typography font="bold" size={0.875}>
        Package delayed.
      </Typography>
      <Typography size={0.875}>We’re refunding your Guaranteed Shipping fees.</Typography>
    </Area>
  )
}

export { MobileRefundedGuaranteedShippingNotification, RefundedGuaranteedShippingNotification }
